import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { offers, Offer } from '../data/product';
interface StickyBuyBarProps {
  selectedOffer: Offer['id'];
}
export function StickyBuyBar({
  selectedOffer
}: StickyBuyBarProps) {
  const offer = offers.find(item => item.id === selectedOffer) ?? offers[1];
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-grit-500/40 bg-ink-950/97 px-4 py-3 backdrop-blur lg:hidden" data-id="element-913" data-mp="37npux4ynsrzs">
      <div className="flex items-center justify-between gap-3" data-id="element-914" data-mp="3lecm8c23bflu">
        <div className="min-w-0" data-id="element-915" data-mp="3hdiwre901squ">
          <p className="truncate font-display text-xl font-extrabold uppercase leading-none text-offwhite" data-id="element-916" data-mp="3heapmhb7pcdf">
            {offer.name}
          </p>
          <p className="mt-1 truncate text-[11px] font-bold uppercase tracking-wide text-grit-500" data-id="element-917" data-mp="3qeqw7zn94zmi">
            {offer.price}
            {offer.compareAt && <span className="ml-1.5 text-steel-500 line-through" data-id="element-918" data-mp="210kljak3eo3s">{offer.compareAt}</span>}
            <span className="text-steel-400" data-id="element-919" data-mp="1w2sltud7hxp1"> · {offer.discountBadge ?? offer.kicker}</span>
          </p>
        </div>
        <a href="#offer" className="inline-flex shrink-0 items-center gap-1.5 bg-grit-500 px-4 py-3.5 font-display text-base font-extrabold uppercase leading-none text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:gap-2 sm:px-5 sm:text-lg" data-id="element-920" data-mp="29cmw4bzll9rw">
          Get the deal
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-921" data-mp="2s4fny32xkoy1" />
        </a>
      </div>
    </div>;
}